import { Text } from '@pairy/pds-react';
import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding-bottom: 180px;
  margin: 96px auto 24px;
  gap: 24px;
`;

export const Title = styled(Text)`
  word-break: keep-all;
`;
